import React, { Component } from 'react'
import NumberFormat from 'react-number-format'

export  default class EmployeeListRow extends Component{

    render(){

        let employeeList;

        if (this.props.employee_list.length === 0){
            employeeList = <tr><td colSpan={6} className="text-center"><span className="text-danger">ไม่พบข้อมูล</span></td></tr>
        }else {

            employeeList = this.props.employee_list.map((employee, index) => {
                return (
                    <tr key={index}>
                        <td className="text-center">{index+1}</td>
                        <td className="text-center">{employee.employee_code}</td>
                        <td className="text-center">{employee.employee_name}&nbsp;&nbsp;{employee.employee_lastname}</td>
                        <td className="text-center">
                            {employee.employee_position} <br/>
                            <NumberFormat value={employee.employee_salary}
                                          displayType={'text'}
                                          thousandSeparator={true}
                                          prefix={'฿'}/>
                        </td>
                        <td className="text-center">{employee.employee_tel}</td>
                        <td className="text-center">

                            <button className="btn btn-sm btn-warning"
                                    onClick={this.props.employeeCallbacks.edit.bind(null, employee)}
                            >
                                <i className="fa fa-edit"></i></button>

                            <button className="btn btn-sm btn-danger"
                                    onClick={this.props.employeeCallbacks.delete.bind(null, employee)}
                            >
                                <i className="fa fa-remove"></i></button>

                        </td>
                    </tr>
                )
            });
        }

        return (

                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th className="text-center">#</th>
                        <th className="text-center">รหัสพนักงาน</th>
                        <th className="text-center">ชื่อ - นามสกุล</th>
                        <th className="text-center">ตำแหน่ง</th>
                        <th className="text-center">เบอร์โทรศัพท์</th>
                        <th className="text-center">จัดการ</th>
                    </tr>
                    </thead>
                    <tbody>
                        {employeeList}
                    </tbody>
                </table>

        )
    }
}